// extracted by mini-css-extract-plugin
export default {"page":"styles_page__8E1vj","content":"styles_content__8RKcQ","bottomContent":"styles_bottomContent__5Z-CU"};